/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 21:54:01
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import { modalFactory } from 'src/util/vueExtend';
import { createNamespace } from 'src/util/bem';
import CompareNoticeApi from './api/compareNoticeApi';
import EnumCompareStatus from 'src/enums/enumCompareStatus';
import { EnumCompareTaskDealStatus, EnumCompareTaskConfirmStatus } from 'src/enums/enumCompareTaskStatus';

export namespace ViewCompareNoticeVOI {
    export interface PropsI {
        operate: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        dispose_company: string;
        inform_number: string;
        initiator: string;
        sponsor_datetime: string;
        comparison_site: {
            operational_equipment: string[];
            operational_content: string;
            operational_site: string;
            affirm_cause: string;
            affirm_condition: number;
            affirm_datatime: string;
            affirm_people: string;
            dispose_condition: string;
            dispose_datatime: string;
            dispose_explain: string;
            dispose_people: string;
        }[];
    }
}

@Component
class ViewCompareNoticeModal extends Vue.Component<ViewCompareNoticeVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: ViewCompareNoticeVOI.FormDataI = {
        dispose_company: '',
        inform_number: '',
        initiator: '',
        sponsor_datetime: '',
        comparison_site: [],
    };
    rules: any = {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

   
    async mounted() {
        let { code, data } = await CompareNoticeApi.searchDetail({ id: this.id });
        if (code === 0) {
            this.formData = {
                dispose_company: data.dispose_company,
                inform_number: data.inform_number,
                initiator: data.initiator,
                sponsor_datetime: data.sponsor_datetime,
                comparison_site: data.comparison_site.data,
            };
        }
    }
    render(h) {
        return (
            <Modal title="对比通知详情" width="1000" v-model={this.visible} mask-closable={false} on-on-cancel={this.close} footer-hide>
                <i-form ref="formValidate" labelWidth={80} class={createNamespace('detail-form')} model={this.formData}>
                    <form-item labelWidth={80} label="通知单号：" style="display: inline-block;width:30%">
                        {this.formData.inform_number}
                    </form-item>
                    <form-item labelWidth={80} label="处理单位：" style="display: inline-block;width:30%">
                        {this.formData.dispose_company}
                    </form-item>
                    <form-item labelWidth={80} label="发起人" style="display: inline-block;width:20%">
                        {this.formData.initiator}
                    </form-item>
                    <form-item labelWidth={80} label="发起时间" style="display: inline-block;width:20%">
                        {this.formData.sponsor_datetime}
                    </form-item>

                    {this.formData.comparison_site.map(i => {
                        return (
                            <div class={createNamespace('mt15')}>
                                <form-item label="对比站点：" style="display: inline-block;width:90%">
                                    {i.operational_site}
                                </form-item>
                                <form-item label="对比设备：" style="display: inline-block;width:90%">
                                    {(i.operational_equipment||[]).join('、')}
                                </form-item>
                                <form-item label="对比内容：" style="display: inline-block;width:90%">
                                    {i.operational_content}
                                </form-item>
                                <form-item label="确认情况：" style="display: inline-block;width:60%">
                                    {EnumCompareTaskConfirmStatus.findId(i.affirm_condition).getName()}
                                </form-item>
                                <form-item v-if={EnumCompareTaskConfirmStatus.现场条件不允许.getId()===i.affirm_condition} label="原因说明：" style="display: inline-block;width:60%">
                                    {i.affirm_cause}
                                </form-item>
                                <form-item label="确认人：" style="display: inline-block;width:30%">
                                    {i.affirm_people}
                                </form-item>
                                <form-item label="确认时间：" style="display: inline-block;width:60%">
                                    {i.affirm_datatime}
                                </form-item>
                                <form-item label="处理情况：" style="display: inline-block;width:30%">
                                    {EnumCompareTaskDealStatus.findId(i.dispose_condition).getName()}
                                </form-item>
                                <form-item label="处理原因：" style="display: inline-block;width:60%">
                                    {i.dispose_explain}
                                </form-item>
                                <form-item label="处理人：" style="display: inline-block;width:30%">
                                    {i.dispose_people}
                                </form-item>
                                <form-item label="处理时间：" style="display: inline-block;width:60%">
                                    {i.dispose_datatime}
                                </form-item>
                            </div>
                        );
                    })}
                </i-form>
            </Modal>
        );
    }
}

export default function alertViewCompareNoticeModal(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<ViewCompareNoticeVOI.PropsI>(ViewCompareNoticeModal)({
            id,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
